<template>
  <div class="case">
    <div>
      <div class="header">
        <div style="padding: 100px">
          <div class="up" style="text-align: center;font-size:32px;">
            <h1 style="font-weight: normal">在门窗行业，让数据驱动制造</h1>
          </div>
          <div class="down" style="text-align: center;margin-top: 20px;font-size: 24px;opacity: 0.7">
            已有1000+高成长制造企业首选「工窗大师」
          </div>
        </div>
      </div>
      <div class="dowebok">
        <ul>
          <li>
            <div class="c-list">
              <div class="c-logo" style="float: left;width: 180px">
                <img src="../assets/img/htd.jpg" style="opacity: 0">
              </div>
              <div class="c-text" style="float: left;padding-top:20px;width:900px;">
                <div class="c-name">
                  <span style="font-size: 26px;font-weight: bold;color: rgb(51, 112, 255)">智能加工流水线</span>
                </div>
                <div class="c-detail">
                  <span class="s-detail">不仅仅是把材料加工数据一股脑的发送给设备，门窗铝材杆件的加工存在不同的打孔工艺，每一根材料的加工时长和复杂程度都有不同，如果存在连续几根杆件加工时间比较长，可能会导致前工序的堵塞，直接影响到整条流水线的加工效率，工窗大师通过将材料工艺复杂度进行拆解分析，根据优化切割结果重新排列，做到各个环节加工难度相对均衡，进而提高加工的流畅度
                    <p style="text-indent: 2rem;">在生产周日日益内卷的当下，整体的快才是真正的快，这就需要在原有加工效率的保证下，进一步促进后续生产环节的同步进行，比如组框、组扇，即在铝材切割打孔的同时进行后续工段，工窗大师根据此类客户特点，将工单进行拆分，根据不同材料同步加工、相同材料尽量配套的原则，完成既保证生产效率，又保证部件材料齐套要求，提高整体生产效能</p></span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="c-list">
              <div class="c-logo" style="float: left;width: 160px">
                <img src="../assets/img/htd.jpg" style="opacity: 0">
              </div>
              <div class="c-text" style="float: left;padding-top:20px;width:900px;margin-left: 10px">
                <div class="c-name">
                  <span style="font-size: 26px;font-weight: bold;color: rgb(51, 112, 255)">产品溯源码</span>
                </div>
                <div class="c-detail">
                  <span class="s-detail">门窗产品一直以来都是消费频次较低的产品，产品在销售市场流通基本上没有任何品牌，厂家标识，类同于三无产品，并且客户在遇到产品问题的情况下根本找不到厂家或者销售方；工窗大师通过将材料采购、设计、下单、生产过程、安装整条产品生产过程数据、产品参数记录到每一樘门窗订单上，并生成二维码，可以激光刻蚀在产品上，方便使用者需要维护的情况下直接连接到厂家进行维修，即便厂家不在，也可以通过二维码上产品参数在市场上自助存求替代配件进行维修</span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="c-list">
              <div class="c-logo" style="float: left;width: 160px">
                <img src="../assets/img/htd.jpg" style="opacity: 0">
              </div>
              <div class="c-text" style="float: left;padding-top:20px;width:900px;margin-left: 10px">
                <div class="c-name">
                  <span style="font-size: 26px;font-weight: bold;color: rgb(51, 112, 255)">兼顾家装工程门窗报价机制</span>
                </div>
                <div class="c-detail">
                  <span class="s-detail">门窗产品因为房地产配套的特殊性，分成了工程和家装两部分，其产品性能验收要求，报价机制、生产方式、安装方式、客户来源和业务形态存在巨大的差异；这就给想跨界同时做家装、工程门窗的厂家造成非常大的困扰，工窗大师将产品设计、业务流程、生产方式结合家装工程门窗企业特点，覆盖家装和工程两大业务形态的所有逻辑，真正实现一个软件，业务灵活，帮助门窗厂实现量的扩大、业务的丰富</span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="c-list">
              <div class="c-logo" style="float: left;width: 160px">
                <img src="../assets/img/htd.jpg" style="opacity: 0">
              </div>
              <div class="c-text" style="float: left;padding-top:20px;width:900px;margin-left: 10px">
                <div class="c-name">
                  <span style="font-size: 26px;font-weight: bold;color: rgb(51, 112, 255)">部件级别生产安排和报工</span>
                </div>
                <div class="c-detail" >
                  <span class="s-detail">在进行生产安排的时候，可以将报工精细到部件级别，比如框、中梃、玻扇等，这样做的好处是对于生产过程中的任务安排自由度非常高，将工艺拆解的更细致，生产员工的部件报工精细到每一个部件和工艺，有利于生产精细化和溯源信息的整理，同时对于产品质量保证起到决定性的作用</span>
                </div>
              </div>
            </div>
          </li>
        </ul>

      </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'first'
    };
  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__content {
  overflow: visible;
  margin-left: -30px;
}

::v-deep .el-tabs__item {
  color: black;
  margin-left: 28px;
}

::v-deep .el-tabs__item.is-active {
  color: #02B980;
  font-size: 24px;
}

::v-deep .el-icon-arrow-left {
  color: black;
  margin-left: 28px;
}

::v-deep .el-icon-arrow-right {
  color: black;
  margin-left: 28px;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 0;
  margin-left: 20px;
}

::v-deep .el-tabs__active-bar {
  background-color: #02B980;
  margin-left: 20px;
}

.cOEJWB {
  cursor: pointer;
  padding: 25px 15px;
  width: 30.33%;
  display: inline-block;
  vertical-align: top;
}

.cOEJWB:hover{
  position: relative;
  top: -12px;
  transition: transform .3s ease-in-out;
}
.cOEJWB .case-overview {
  height: 400px;
  min-height: 40vh;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgb(238, 238, 238);
}
.dowebok {
  height: 1000px !important;
  overflow-y: scroll;
  position: relative;
  width: 1280px;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}
.dowebok::-webkit-scrollbar{
  display: none;
}
.dowebok ul {
  margin: 0 auto;
  left: 0px;
  right: 0px;
  position: absolute;
}
.c-list {
  margin: 40px auto;
  min-height: 180px;
  width: 1200px;
  overflow: hidden;
  height: auto;
  box-shadow: 1px 1px 10px #f6f7fb;
}
.c-detail{
  text-indent:2rem;
  margin-top: 10px;
  border: 1px solid rgb(51, 112, 255);
  padding: 10px;
  border-radius: 10px;
}
.c-detail span {
  color: #666666;
  font-size: 16px;
  line-height: 30px;
}




</style>
